const DB_NAME = 'neku-sticker-src'
const STORE = 'zips'
const DB_VERSION = 1

type Row = {
  tid: string
  sha: string
  blob: Blob
}

const memory = new Map<string, Row>()

const openDb = (): Promise<IDBDatabase> =>
  new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('indexedDB unavailable'))
      return
    }
    const req = indexedDB.open(DB_NAME, DB_VERSION)
    req.onupgradeneeded = () => {
      const db = req.result
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: 'tid' })
      }
    }
    req.onsuccess = () => resolve(req.result)
    req.onerror = () => reject(req.error)
  })

/** 按模板记下最近一份画师 zip。sha 变了就当没命中。 */
export async function readCachedSrc(tid: string, sha: string): Promise<Blob | null> {
  const hit = memory.get(tid)
  if (hit?.sha === sha) return hit.blob
  try {
    const db = await openDb()
    const row = await new Promise<Row | undefined>((resolve, reject) => {
      const req = db.transaction(STORE, 'readonly').objectStore(STORE).get(tid)
      req.onsuccess = () => resolve(req.result as Row | undefined)
      req.onerror = () => reject(req.error)
    })
    if (!row || row.sha !== sha || !row.blob) return null
    memory.set(tid, row)
    return row.blob
  } catch {
    return null
  }
}

export async function writeCachedSrc(tid: string, sha: string, blob: Blob) {
  const row: Row = { tid, sha, blob }
  memory.set(tid, row)
  try {
    const db = await openDb()
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite')
      tx.objectStore(STORE).put(row)
      tx.oncomplete = () => resolve()
      tx.onerror = () => reject(tx.error)
    })
  } catch {
    // 缓存写失败不影响这次打开或保存
  }
}
